export enum ETransformRuleActionType {
  LOGIC_OPERATOR_CHANGE,
  ADD_TRANSFORM_METADATA_GROUP,
  ADD_AND_TRANSFORM_METADATA_ITEM,
  ADD_OR_TRANSFORM_METADATA_ITEM,
  DELETE_TRANSFORM_METADATA_GROUP,
  DELETE_TRANSFORM_METADATA_ITEM,
  DELETE_ALL_TRANSFORM,
}
